export class AdvancedWorkflows {
  public static wfs = [
    {
      // Profil SeSe - main workflow (created first)
      appliesto: '',
      attachment: '',
      attachmentURL: '',
      calendlyLink: '',
      document: '',
      documentName: 'Profil Lang Demo',
      documentURL:
        'https://firebasestorage.googleapis.com/v0/b/mona-recruiting-instance2.firebasestorage.app/o/filesStorage%2F1757344326152_Selfservice_Profil-LANG.docx?alt=media&token=dd630d77-2f3c-4513-b977-de21763c5f42',
      dothis: 'email',
      dynamicAttachment: 'applicantProfile',
      emailText: '',
      id: '',
      information: ['dynamicAttachments'],
      lastChosenWorkflow: '',
      lastChosenWorkflowMatching: { name: 'Profil SeSe' },
      name: 'Profil SeSe',
      priorityOfWorkflow: 'below',
      prompt: '',
      receiver: 'customer',
      smsCountryCode: '',
      smsText: '',
      status: 'aktiv',
      subWorkflows: [],
      when: 'now',
      whenthishappens: 'flowchartknot',
      workflowSendEmailMessage:
        'Der Bewerber hat gerade eben das Interview abgeschlossen. Das entsprechende Profil ist anbei. VIel Erfolg beim Vermittlungsprozes.',
      workflowSendEmailSubject: '',
      workflowSendEmailTitle: '',
      smsPhoneNumbers: [],
      callPhoneNumbers: [],
      whatsAppPhoneNumbers: [],
      customTime: {},
      reminder: {},
      agent: {},
    },
    {
      // Matching SeSe - subworkflow of Profil SeSe (created second)
      appliesto: '',
      attachment: '',
      attachmentURL: '',
      calendlyLink: '',
      document: '',
      documentName: 'Profil Teaser Demo',
      documentURL:
        'https://firebasestorage.googleapis.com/v0/b/mona-recruiting-instance2.firebasestorage.app/o/filesStorage%2F1757344145098_Selfservice_Profil-Teaser.docx?alt=media&token=279d1ba2-9c49-44cc-a4b4-cf6b950bd3aa',
      dothis: 'email',
      dynamicAttachment: 'applicantProfileForDisponentAndMatching',
      emailText: '',
      id: '',
      information: ['dynamicAttachments'],
      lastChosenWorkflow: 'Profil SeSe ',
      lastChosenWorkflowMatching: { name: 'Matching SeSe' },
      name: 'Matching SeSe',
      priorityOfWorkflow: 'superior',
      prompt: '',
      receiver: 'customer',
      smsCountryCode: '',
      smsText: '',
      status: 'aktiv',
      subWorkflows: [],
      when: 'now',
      whenthishappens: 'flowchartknot',
      workflowSendEmailMessage:
        '<!DOCTYPE html> <html lang="de"> <head> <meta charset="UTF-8"> <title>Kandidatenvorstellung</title> </head> <body style="font-family: Arial, sans-serif; font-size: 14px; color: #000; line-height: 1.6;"> <p>Sehr geehrte Damen und Herren,</p> <p> Wir haben eine Kandidatin oder einen Kandidaten gefunden, die oder der sowohl fachlich als auch persönlich ideal zu den Anforderungen Ihrer zukünftigen Fach- und Führungskräfte passt. Durch unsere gezielte Marktbeobachtung erkennen wir frühzeitig, welche Qualifikationen und Kompetenzen für Ihr Unternehmen besonders wertvoll sind. </p> <p> Ihrer Stellenanzeige konnten wir entnehmen, dass Sie nach der Position: <strong>WP_jobTitle</strong> suchen. Wir haben die drei wesentlichen Anforderungen erkannt, die Sie in Ihrer Anzeige betont haben: </p> <ul> <li>WP_SuchKriterien1</li> <li>WP_SuchKriterien2</li> <li>WP_SuchKriterien3</li> </ul> <p> Wir möchten Ihnen ein passendes Kandidatenprofil vorstellen, das nicht nur Ihre Anforderungen erfüllt, sondern darüber hinaus weitere Vorteile bietet: </p> <ul> <li>✔ WP_MatchingKriterien1</li> <li>✔ WP_MatchingKriterien2</li> <li>✔ WP_MatchingKriterien3</li> </ul> <p> Was halten Sie von unserem Kurzprofil im Anhang? Weitere Einzelheiten zum Profil können wir Ihnen direkt im Nachgang zukommen lassen. Bitte melden Sie sich möglichst zeitnah. Nur so können wir gemeinsam sicherstellen, dass Sie mit uns Ihre Stellen schneller als der Wettbewerb besetzen und so kurz- wie langfristige Kosten durch eine passgenaue Besetzung vermeiden können. </p> <p> Termine für ein persönliches Kennenlernen mit einem oder mehreren Kandidaten lassen sich kurzfristig vereinbaren. </p> <p> Die persönlichen Kontaktdaten des zuständigen Personalberaters finden Sie am Ende des angehängten Kurzprofils. </p>Freundliche Grüße </p> <p><strong>MONA LISA</strong><br> Digital Recruiting Team<br> <p><strong>MONA AI GmbH</strong></p> <img class="logo" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAGKCAYAAACfAGucAAAACXBIWXMAAC4jAAAuIwF4pT92AAB3HUlEQVR4nO3dd3wU1frH8c/spvdAqIode++9VxBFRUUFwX5toGL/efXarr23a++9gaJiF3vvDTvSSe999/fHJJhNgGSSOTszu9/365WXsnv2mQcIm33mnPMcKxqNIiIiIiIiIiLeCnmdgIiIiIiIiIiIioQBcRERERERHxBRXoIiIiIiIiIj6gAl1ERERERETEB1Sgi4iIiIiIiPiACnQRERERERERH1CBLiIiIiIiIuIDKtBFREREREREfEAFuoiIiIiIiIgPqEAXERERERER8QEV6CIiIiIiIiI+oAJdRERERERExAdUoIuIiIiIiIj4gAp0ERERERERER9QgS4iIiIiIiLiAyrQRURERERERHxABbqIiIiIiIiID6hAFxEREREREfEBFegiIiIiIiIiPqACXURERERERMQHVKCLiIiIiIiI+IAKdBEREREREREfUIEuIiIiIiIi4gMq0EVERERERER8QAW6iIiIiIiIiA+oQBcRERERERHxARXoIiIiIiIiIj6gAl1ERERERETEB1Sgi4iIiIiIiPiACnQRERERERERH1CBLiIiIiIiIuIDKtBFREREREREfEAFuoiIiIiIiIgPqEAXERERERER8QEV6CIiIiIiIiI+8P9H8baaSzRrJgAAAABJRU5ErkJggg==" style="max-width: 200px; height: auto;" alt="Logo MONA AI GmbH"> <p>Tel: +49 6861 80729-0<br> E-Mail: kontakt@mona-ai.de<br> Web: https://www.mona-ai.de<br> </p> <p>Adresse: Campus Universität des Saarlandes | Starterzentrum A1 1 | D-66123 Saarbrücken<br> Handelsregisternummer: HRB 108515 | Geschäftsführer: Felix Adam und Denis Franz </p> <p>Hinweis:<br> Sie erhalten diese E-Mail, da Sie uns beauftragt haben, Sie bei der Besetzung einer Stelle zu unterstützen.<br> Dieses Dokument enthält personenbezogene Daten nach EU-DSGVO – bitte entsprechend vertraulich behandeln.<br> Die Nutzung ist nur gemäß unseren AGB erlaubt. </p> </body> </html> ',
      workflowSendEmailSubject: '',
      workflowSendEmailTitle: '',
      smsPhoneNumbers: [],
      callPhoneNumbers: [],
      whatsAppPhoneNumbers: [],
      customTime: {},
      reminder: {},
      agent: {},
    },
    {
      // Termin SeSe - separate workflow
      appliesto: '',
      attachment: '',
      attachmentURL: '',
      calendlyLink: '',
      document: '',
      documentName: '',
      documentURL: '',
      dothis: 'calendly',
      dynamicAttachment: '',
      emailText: '',
      id: '',
      information: [],
      lastChosenWorkflow: '',
      lastChosenWorkflowMatching: { name: 'Termin SeSe' },
      name: 'Termin SeSe',
      priorityOfWorkflow: 'below',
      prompt: '',
      receiver: 'customer',
      smsCountryCode: '',
      smsText: '',
      status: 'aktiv',
      subWorkflows: [],
      when: 'now',
      whenthishappens: 'calendly',
      workflowSendEmailMessage: '',
      workflowSendEmailSubject: 'nach Eingang der Bewerbung versenden',
      workflowSendEmailTitle: '',
      smsPhoneNumbers: [],
      callPhoneNumbers: [],
      whatsAppPhoneNumbers: [],
      customTime: {},
      reminder: {
        betreffText: 'Buche dir jetzt deinen Kennenlern-Termin',
        emailText:
          'Hallo $firstname, du hast dich erfolgreich für den Job bei $companyname beworben. Anbei bekommst du einen Link um dir einen Kennenlern-Termin zu buchen. $calendlyURL Wenn du dir bereits einen Termin im Interview gebucht hast, kanst du diese Email ignorieren. ',
        smsText:
          ' Hallo $firstname, du hast dich erfolgreich für den Job bei $companyname beworben. Anbei bekommst du einen Link um dir einen Kennenlern-Termin zu buchen. $calendlyURL Wenn du dir bereits einen Termin im Interview gebucht hast, kannst du diese SMS ignorieren. ',
        smsCountryCode: '',
      },
      agent: {},
    },
  ];
}


